var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 658,
    height: 229,
    viewBox: "0 0 658 229",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M656.679 91.4033C656.679 91.4033 254.762 176.803 -2.50196 86.5",
    stroke: "#FCBC5C",
    strokeOpacity: 0.44,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M630.664 2C630.664 2 442.607 209.603 -0.500024 175",
    stroke: "#FCBC5C",
    strokeOpacity: 0.44,
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowLines);
export default __webpack_public_path__ + "static/media/yellowLines.53b79995846766f7f0eb7f86735a8b36.svg";
export { ForwardRef as ReactComponent };